module.exports = __webpack_public_path__ + "static/media/data.57aa7be9.md";